export function parseLocalizedInt(str) {
	str = str || "";
	str = str.replace(/[^-0-9,\.]/g, "");
	return parseInt(str);
}

export function formatCurrency(num) {
	num = num || 0;
	return num.toLocaleString("cs-CZ") + " Kč";
}